import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AbilityService } from 'ability';
import { I18NextPipe } from 'angular-i18next';
import { ModalService } from 'mbs-ui-kit/modal/modal.service';
import { ManageLicenseAdminModalComponent } from 'mbs-ui-shared@components/licenses/components/manage-license-admin-modal/manage-license-admin-modal.component';
import { AdministratorsFacade } from 'mbs-ui-shared@facades/administrators.facade';
import { AuthFacade } from 'mbs-ui-shared@facades/auth.facade';
import { LicensesFacade } from 'mbs-ui-shared@facades/licenses.facade';
import { LicenseType } from 'mbs-ui-shared@models';
import { FilterLicenseAndAdminId } from 'mbs-ui-shared@models/License';
import { LicensesService } from 'mbs-ui-shared@services/licenses.service';
import { Observable, catchError, from, map, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LicensesPostPaymentFacade extends LicensesFacade {
  protected licensesService: LicensesService;
  protected modal: ModalService;
  protected i18nPipe: I18NextPipe;
  protected auth: AuthFacade;
  protected adminFacade: AdministratorsFacade;
  protected router: Router;
  protected ability: AbilityService;
  protected store: Store;

  constructor() {
    const licensesService = inject(LicensesService);
    const modal = inject(ModalService);
    const i18nPipe = inject(I18NextPipe);
    const auth = inject(AuthFacade);
    const adminFacade = inject(AdministratorsFacade);
    const router = inject(Router);
    const ability = inject(AbilityService);
    const store = inject(Store);

    super();

    this.licensesService = licensesService;
    this.modal = modal;
    this.i18nPipe = i18nPipe;
    this.auth = auth;
    this.adminFacade = adminFacade;
    this.router = router;
    this.ability = ability;
    this.store = store;
  }

  public openAdminLicenseModal(data: FilterLicenseAndAdminId): Observable<boolean> {
    return from(
      this.modal.openCustom(ManageLicenseAdminModalComponent, {
        data: {
          title: this.i18nPipe.transform('shared:licenses.manageModal:assignTitle', {
            format: 'title'
          }),
          entityId: data.adminID
        }
      })
    ).pipe(
      map(() => true),
      catchError(() => of(false))
    );
  }

  public openGrantLicenseDialogue(
    adminId: string,
    filter: LicenseType[] = null,
    withTrials = false,
    defaultFilter = true,
    email = ''
  ): Observable<boolean> {
    return super.openGrantLicenseDialogue(adminId, filter, withTrials, defaultFilter, email, ManageLicenseAdminModalComponent);
  }

  public openGrantLicenseDialogueWithInfoModal(data: FilterLicenseAndAdminId) {
    return super.openGrantLicenseDialogueWithInfoModal(data, this.i18nPipe.transform('shared:licenses.actions.assign'));
  }
}
